var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQobuzColorDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 50,
    viewBox: "0 0 111 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Qobuz"
  }, /*#__PURE__*/React.createElement("g", {
    id: "qobuz-light"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Qobuz_logotype"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.673,
    cy: 24.9462,
    r: 12.673,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46704 24.945C2.46704 19.309 7.03604 14.739 12.673 14.739C18.31 14.739 22.879 19.308 22.879 24.945C22.879 30.582 18.309 35.152 12.673 35.152C7.03704 35.152 2.46704 30.581 2.46704 24.945ZM8.65804 24.945C8.65804 27.162 10.456 28.96 12.673 28.96C14.891 28.96 16.688 27.163 16.688 24.945C16.688 22.728 14.89 20.93 12.673 20.93C10.456 20.93 8.65804 22.728 8.65804 24.945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2",
    cx: 12.673,
    cy: 24.9462,
    r: 0.871,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.79297 24.7382C7.90197 22.1362 10.045 20.0602 12.673 20.0602C15.301 20.0602 17.445 22.1362 17.553 24.7382H22.1C21.989 19.6252 17.813 15.5132 12.673 15.5132C7.53297 15.5132 3.35597 19.6252 3.24597 24.7382H7.79297Z",
    fill: "url(#paint0_linear_108_356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M12.673 15.5149V20.0619C15.302 20.0949 17.492 22.2039 17.556 24.8259H22.103C22.039 19.6929 17.814 15.5479 12.673 15.5149Z",
    fill: "url(#paint1_linear_108_356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M12.673 15.5149V20.0619C10.044 20.0949 7.85597 22.2039 7.79297 24.8259H3.24597C3.30997 19.6929 7.53297 15.5479 12.673 15.5149Z",
    fill: "url(#paint2_linear_108_356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M19.395 32.623C17.599 34.196 15.249 35.152 12.674 35.152C12.664 35.152 12.654 35.151 12.644 35.151V37.618C12.654 37.618 12.664 37.619 12.674 37.619C15.868 37.619 18.784 36.435 21.013 34.485C20.478 33.859 19.921 33.253 19.395 32.623Z",
    fill: "url(#paint3_linear_108_356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M25.201 36.0281L18.364 29.1761C18.162 28.9091 17.843 28.7351 17.483 28.7351C16.873 28.7351 16.379 29.2291 16.379 29.8391C16.379 30.1361 16.497 30.4051 16.688 30.6041C16.701 30.6171 16.714 30.6301 16.728 30.6431L23.695 37.4551L25.201 36.0281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.288 25.0001C51.288 20.7351 54.746 17.2771 59.011 17.2771C63.276 17.2771 66.734 20.7351 66.734 25.0001C66.734 29.2651 63.276 32.7231 59.011 32.7231C54.746 32.7231 51.288 29.2651 51.288 25.0001ZM53.933 25.0001C53.933 27.8051 56.207 30.0781 59.011 30.0781C61.815 30.0781 64.089 27.8041 64.089 25.0001C64.089 22.1951 61.815 19.9221 59.011 19.9221C56.206 19.9221 53.933 22.1961 53.933 25.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M41.943 17.2771C37.678 17.2771 34.22 20.7351 34.22 25.0001C34.22 29.2651 37.678 32.7231 41.943 32.7231C43.409 32.7231 44.78 32.3141 45.948 31.6051V28.1201C45.019 29.3111 43.571 30.0781 41.943 30.0781C39.139 30.0781 36.865 27.8051 36.865 25.0001C36.865 22.1961 39.138 19.9221 41.943 19.9221C44.747 19.9221 47.021 22.1951 47.021 25.0001V30.8161V38.9421C47.021 39.6721 47.613 40.2641 48.343 40.2641C49.073 40.2641 49.665 39.6721 49.665 38.9421V25.0001C49.666 20.7351 46.209 17.2771 41.943 17.2771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M76.041 32.7231C80.306 32.7231 83.764 29.2651 83.764 25.0001C83.764 20.7351 80.306 17.2771 76.041 17.2771C74.575 17.2771 73.204 17.6861 72.036 18.3951V21.8801C72.965 20.6891 74.413 19.9221 76.041 19.9221C78.845 19.9221 81.119 22.1951 81.119 25.0001C81.119 27.8041 78.846 30.0781 76.041 30.0781C73.237 30.0781 70.963 27.8051 70.963 25.0001V19.1841V11.0581C70.963 10.3281 70.371 9.73608 69.641 9.73608C68.911 9.73608 68.319 10.3281 68.319 11.0581V25.0001C68.318 29.2651 71.776 32.7231 76.041 32.7231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M91.892 32.7231C87.569 32.7231 85.51 28.8561 85.51 26.8721C85.51 24.8881 85.51 18.6001 85.51 18.6001C85.51 17.8701 86.102 17.2781 86.833 17.2781C87.563 17.2781 88.155 17.8701 88.155 18.6001C88.155 18.6001 88.155 25.6741 88.155 26.5731C88.155 27.4721 88.392 30.0791 91.985 30.0791C94.979 30.0791 95.628 28.1081 95.628 27.0971C95.628 26.0861 95.628 18.6001 95.628 18.6001C95.628 17.8701 96.22 17.2781 96.951 17.2781C97.681 17.2781 98.273 17.8701 98.273 18.6001C98.273 18.6001 98.273 25.4121 98.273 27.0221C98.274 28.6311 96.777 32.7231 91.892 32.7231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M109.684 32.7231C110.411 32.7231 111 32.1341 111 31.4071C111 30.6801 110.411 30.0911 109.684 30.0911H103.477L108.829 22.8681C110.925 20.0611 111 19.9491 111 19.1631C111 18.2651 110.102 17.3911 109.203 17.3911C108.305 17.3911 101.387 17.3911 101.387 17.3911C100.66 17.3911 100.071 17.9801 100.071 18.7071C100.071 19.4341 100.66 20.0231 101.387 20.0231H107.781C107.781 20.0231 100.969 29.0061 100.37 29.8291C99.771 30.6521 100.108 32.7231 101.717 32.7231C103.326 32.7231 109.684 32.7231 109.684 32.7231Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_356",
    x1: 3.24617,
    y1: 24.7384,
    x2: 22.1008,
    y2: 24.7384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8763
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_108_356",
    x1: 9.11655,
    y1: 19.9109,
    x2: 16.4265,
    y2: 26.4457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#B5B5B5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1244,
    stopColor: "#969696",
    stopOpacity: 0.1632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    stopColor: "#2B2B2B",
    stopOpacity: 0.7421
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_108_356",
    x1: 9.70744,
    y1: 12.6119,
    x2: 2.39629,
    y2: 19.1437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#B5B5B5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1244,
    stopColor: "#969696",
    stopOpacity: 0.1632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5553,
    stopColor: "#2B2B2B",
    stopOpacity: 0.7421
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_108_356",
    x1: 17.8008,
    y1: 38.9642,
    x2: 21.2224,
    y2: 32.4241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#B5B5B5",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0486,
    stopColor: "#A8A8A8",
    stopOpacity: 0.0514
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2682,
    stopColor: "#6C6C6C",
    stopOpacity: 0.2982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4701,
    stopColor: "#3E3E3E",
    stopOpacity: 0.5252
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6478,
    stopColor: "#1C1C1C",
    stopOpacity: 0.725
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7947,
    stopColor: "#070707",
    stopOpacity: 0.8901
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8925
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQobuzColorDark);
export default __webpack_public_path__ + "static/media/qobuz-color-dark.04204a332babacafba95b055739ff514.svg";
export { ForwardRef as ReactComponent };